import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class Campaign {
  private readonly http = inject(HttpClient);

  packageList(filters: any): Observable<any> {
    return this.http.get<any>(`${environment.apiPrefix}${environment.package.packageList}`, {
      params: filters
    });
  }

  validateCampaign(data: any): Observable<any> {
    return this.http.post<any>(
      `${environment.apiPrefix}${environment.message.validateCampaign}`,
      data
    );
  }

  sendCampaign(data: any): Observable<any> {
    return this.http.post<any>(`${environment.apiPrefix}${environment.message.campaign}`, data);
  }

  downloadSampleCampaign(filters: any): Observable<Blob> {
    return this.http.get(`${environment.apiPrefix}${environment.message.downloadSampleCampaign}`, {
      params: filters,
      responseType: 'blob'
    });
  }
}
